import UserClient from './api/UserClient';

export default function (store) {
  return {
    data() {
        return {
            userClient: new UserClient(this.$http),
            currentUser: null,
            store,
            communicationPreferences: []
        }
    },
    methods: {
      async initialize() {
        this.currentUser = await this.getUser();

        if (this.currentUser) {
            await this.initializeForKnownUser(this.currentUser);
        }

        store.commit('setUser', this.currentUser);
      },
      async getUser() {
        try {
          await this.userClient.syncIdentity();
          return await this.userClient.getRemoteUser();
        } catch (ex) {
          console.error(ex)
          return null;
        }
      },
      async initializeForKnownUser(user) {
          this.$globals.getUnreadCounts(user);

          this.$gtag.event('login');
          this.$gtag.set('user_properties', {
            user_id: user.id.toString(),
            user_type: user.userTypeDisplay
          });

          if (window.clarity) {
            window.clarity('identify', user.id.toString());
            window.clarity('set', 'user_id', user.id.toString());
            window.clarity('set', 'user_type', user.userTypeDisplay);
            window.clarity('set', 'bettermynd_version', window.betterMynd.version);
          }

          this.communicationPreferences = await this.getCommunicationPreferences();
      },
      isInitialized() {
        return !!this.currentUser;
      },
      getHomeRoute() {
        if (!this.currentUser) return null;

        if (this.currentUser.isStudent) {
          if (this.currentUser.needsWelcome) return 'welcome';
          if (this.currentUser.needsSurvey && !this.currentUser.skippedSurvey) return 'mental-health-survey';

          return 'student-dashboard';
        }

        if (this.currentUser.isCounselor) {
          if (this.currentUser.needsWelcome) return 'counselor-welcome';
          if (!this.currentUser.hasInitializedCal) return 'availability';

          return 'counselor-dashboard';
        }

        if (this.currentUser.isCollegeAdmin) return 'college-dashboard';
        if (this.currentUser.isAdmin) return 'admin-dashboard';

        return 'dashboard';
      },
      async getCommunicationPreferences() {
        const response = await this.userClient.getCommunicationPreferences(this.currentUser.id).catch(console.error);
        return response || [];
      },
      async setCommunicationPreferences(preferences) {
        try {
          await this.userClient.setCommunicationPreferences(this.currentUser.id, preferences);
          this.communicationPreferences = { preferences };
        } catch (ex) {
          console.error(ex);
        }
      },
    }
  }
}
